import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c2c21fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-header" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "c-header__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandLogo = _resolveComponent("BrandLogo")!
  const _component_ABody = _resolveComponent("ABody")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("a", {
      class: "c-header__link",
      href: _ctx.plusUrl
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BrandLogo),
        _createVNode(_component_ABody, {
          class: "c-header__a-body",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode("次のキャリアが見える、転職サイト")
          ], undefined, true),
          _: 1
        })
      ])
    ], 8, _hoisted_2)
  ]))
}